// extracted by mini-css-extract-plugin
module.exports = {"bottomMark":"BottomMark_bottomMark__WIzxL"};